import React from 'react';
import { FormField } from '../../../types/formBuilder';

interface BasicFieldSettingsProps {
  field: FormField;
  onUpdate: (updates: Partial<FormField>) => void;
}

export const BasicFieldSettings: React.FC<BasicFieldSettingsProps> = ({ field, onUpdate }) => {
  return (
    <div className="space-y-4">
      {/* Field Label */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-th-primary">
          Field Label *
        </label>
        <input
          type="text"
          value={field.label}
          onChange={(e) => onUpdate({ label: e.target.value })}
          placeholder="Enter field label"
          className="w-full bg-elevated border border-subtle rounded-lg px-4 py-3 text-th-primary placeholder-th-tertiary focus:border-brand focus:outline-none transition-all"
        />
        <p className="text-xs text-th-secondary">
          The label displayed to users for this field
        </p>
      </div>

      {/* Variable Name */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-th-primary">
          Variable Name *
        </label>
        <input
          type="text"
          value={field.variable_name}
          onChange={(e) => onUpdate({ variable_name: e.target.value })}
          placeholder="input_concept"
          className="w-full bg-elevated border border-subtle rounded-lg px-4 py-3 text-th-primary placeholder-th-tertiary focus:border-brand focus:outline-none transition-all font-mono"
        />
        <p className="text-xs text-th-secondary">
          API parameter name (e.g., "input_concept", "style", "camera_direction")
        </p>
      </div>

      {/* Placeholder */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-th-primary">
          Placeholder Text
        </label>
        <input
          type="text"
          value={field.placeholder || ''}
          onChange={(e) => onUpdate({ placeholder: e.target.value })}
          placeholder="Enter placeholder text"
          className="w-full bg-elevated border border-subtle rounded-lg px-4 py-3 text-th-primary placeholder-th-tertiary focus:border-brand focus:outline-none transition-all"
        />
        <p className="text-xs text-th-secondary">
          Hint text shown inside the input field
        </p>
      </div>

      {/* Description / Help Text */}
      <div className="space-y-2">
        <label className="block text-sm font-medium text-th-primary">
          Description / Help Text
        </label>
        <textarea
          value={field.description || ''}
          onChange={(e) => onUpdate({ description: e.target.value })}
          placeholder="Explain what this field is for"
          rows={3}
          className="w-full bg-elevated border border-subtle rounded-lg px-4 py-3 text-th-primary placeholder-th-tertiary focus:border-brand focus:outline-none resize-none transition-all"
        />
        <p className="text-xs text-th-secondary">
          Help text displayed below the field
        </p>
      </div>
    </div>
  );
};